export default "__VITE_ASSET__DgsHkJI1__"